/**
 * Snapshot éditable devis NR2J — dirty guard vs rehydrate serveur.
 * Exporté pour tests déterministes (pas de React).
 */

export function serializeNr2jQuoteEditableForm({
  lines = [],
  contactId = '',
  validUntil = '',
  clientNote = '',
  internalNote = '',
} = {}) {
  return JSON.stringify({
    contactId: contactId || '',
    validUntil: validUntil || '',
    clientNote: clientNote || '',
    internalNote: internalNote || '',
    lines: (lines || []).map((l) => ({
      catalogItemId: l.catalogItemId || '',
      name: l.name || '',
      description: l.description || '',
      quantity: Number(l.quantity) || 1,
      priceEuros: String(l.priceEuros ?? ''),
      vatRateBps: Number(l.vatRateBps) || 0,
      billingType: l.billingType || 'ONE_TIME',
      discountMode: l.discountMode || 'none',
      discountPercent: String(l.discountPercent ?? ''),
      discountEuros: String(l.discountEuros ?? ''),
    })),
  });
}

/**
 * Décide si un reload silencieux peut réinjecter le formulaire serveur.
 * @returns {'apply'|'preserve'}
 */
export function nr2jQuoteSilentReloadFormAction({ silent, formDirty }) {
  if (silent && formDirty) return 'preserve';
  return 'apply';
}
